<template>
  <div class="view-container">
    <div class="serve-top">
      <div class="serve-content">
        <div class="return-btn" @click="returnClick"></div>
        <div class="serve-title">{{ viewInfo.name }}</div>
        <div class="price">
          <span class="price_1">¥</span>
          <span class="price_2">{{ viewInfo.score }}</span>
          <span class="price_3" style="color: #121212">/次</span>
        </div>
        <div class="serve-time" v-if="viewInfo.frequencyCount">
          <span class="serve-time_title">服务时长</span>
          <span class="serve-time_num">{{ viewInfo.frequencyCount }}</span>
          <span class="serve-time_unit">分钟</span>
        </div>
        <div class="serve-tag">
          <span v-if="viewInfo.typeName" class="tag tag1">{{
            viewInfo.typeName
          }}</span>
          <span v-if="viewInfo.type == 1" class="tag tag2">政府补贴服务</span>
          <span v-if="viewInfo.type == 2" class="tag tag3">机构服务</span>
        </div>
      </div>
    </div>
    <div class="serve-bottom">
      <div class="serve-bottom_title">服务项目内容</div>
      <div class="serve-bottom_container">
        {{ viewInfo.description }}
      </div>
    </div>
    <div class="serve-btnbox">
      <div class="submit-btn" @click="upclick">立即下单</div>
    </div>
  </div>
</template>

<script>
import { getServeInfo, assistServiceType } from "@/api/attest";
import { Dialog } from "vant";
const imgUrl1 = require("@/assets/1.png");
const imgUrl2 = require("@/assets/2.png");
const imgUrl3 = require("@/assets/3.png");
const imgUrl4 = require("@/assets/4.png");
const imgUrl5 = require("@/assets/5.png");
const imgUrl6 = require("@/assets/6.png");
const imgUrl7 = require("@/assets/7.png");
const imgUrl8 = require("@/assets/8.png");
const imgUrl9 = require("@/assets/9.png");
const imgUrl10 = require("@/assets/10.png");
const imgUrl11 = require("@/assets/11.png");
const imgUrl12 = require("@/assets/12.png");
export default {
  data() {
    this.imgUrl1 = imgUrl1;
    this.imgUrl2 = imgUrl2;
    this.imgUrl3 = imgUrl3;
    this.imgUrl4 = imgUrl4;
    this.imgUrl5 = imgUrl5;
    this.imgUrl6 = imgUrl6;
    this.imgUrl7 = imgUrl7;
    this.imgUrl8 = imgUrl8;
    this.imgUrl9 = imgUrl9;
    this.imgUrl10 = imgUrl10;
    this.imgUrl11 = imgUrl11;
    this.imgUrl12 = imgUrl12;
    return {
      viewInfo: {},
      serveImage: "",
    };
  },

  methods: {
    // 判断照片
    imageOption(image, type) {
      if (image) {
        return image;
      } else {
        switch (type) {
          case "八助":
            return imgUrl1;
          case "助急服务":
            return imgUrl2;
          case "助餐服务":
            return imgUrl3;
          case "医疗保健":
            return imgUrl4;
          case "固定服务":
            return imgUrl5;
          case "室外活动陪护":
            return imgUrl6;
          case "家政服务":
            return imgUrl7;
          case "康复训练":
            return imgUrl8;
          case "文化娱乐":
            return imgUrl9;
          case "点餐服务":
            return imgUrl10;
          case "生活照料服务":
            return imgUrl11;
          case "精神慰藉":
            return imgUrl12;
        }
      }
    },
    returnClick() {
      this.$router.go(-1);
    },
    upclick() {
      Dialog.confirm({
        title: "联系电话",
        confirmButtonText: "呼叫",
        message: this.viewInfo.companyPhone,
      }).then(() => {
        window.location.href = `tel:${this.viewInfo.companyPhone}`; //调起手机端呼叫功能
      });
    },
    getServiceType(id) {
      assistServiceType(id).then((res) => {
        console.log(res.data);
      });
    },
    getInfo() {
      getServeInfo({
        id: this.$route.query.id,
      }).then((res) => {
        this.viewInfo = res.data;
        this.serveImage = this.imageOption(
          this.viewInfo.image,
          this.viewInfo.typeName
        );
      });
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style lang="less" scoped>
.view-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .serve-top {
    width: 100%;
    background-color: #fff;
    border-bottom: 10px solid #f5f5f5;
    padding-bottom: 22px;

    .serve-img {
      width: 100%;
      height: 296px;
      background: #ededed;
      position: relative;
    }

    .img-have {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .img-null {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 40px;
      height: 31px;
    }

    .serve-content {
      position: relative;
      padding: 70px 16px 22px;
      background-color: #fff;
      .return-btn {
        position: absolute;
        top: 18px;
        left: 16px;
        width: 27px;
        height: 27px;
        background: #121212 url("../../assets/return.png") no-repeat center;
        background-size: 8px 13px;
        background-position: 8px 7px;
        border-radius: 50%;
      }
      .price {
        line-height: 17px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fb452d;
        margin-bottom: 24px;
        &_1 {
          font-size: 14px;
        }
        &_2 {
          font-size: 27px;
          padding: 0 6px;
        }
        &_3 {
          font-size: 16px;
        }
      }
      .serve-title {
        height: 20px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #292a2d;
        line-height: 20px;
        margin-bottom: 16px;
      }
      .serve-time {
        margin-bottom: 24px;
        &_title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #686868;
          line-height: 10px;
        }
        &_num {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #1779ff;
          line-height: 10px;
          padding: 0 3px 0 5px;
        }
        &_unit {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #1779ff;
          line-height: 12px;
        }
      }
      .serve-tag {
        height: 21px;
        .tag {
          padding: 4px 6px;
          height: 21px;
          border-radius: 2px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          line-height: 21px;
          margin-right: 5px;
        }
        .tag1 {
          background: linear-gradient(90deg, #1779ff, #4996ff);
        }
        .tag2 {
          background: #03d785;
        }
        .tag3 {
          background: #f1991b;
        }
      }
    }
  }
  .serve-bottom {
    width: 100%;
    background-color: #fff;
    padding: 23px 16px 0;
    margin-bottom: 4px;
    padding-bottom: 150px;
    &_title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #121212;
      line-height: 20px;
      margin-bottom: 17px;
    }
    &_container {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #121212;
      line-height: 20px;
    }
  }
  .serve-btnbox {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99;
    width: 100%;
    height: 68px;
    background-color: #fff;
    .submit-btn {
      position: absolute;
      top: 9px;
      left: 50%;
      transform: translateX(-50%);
      width: 342px;
      height: 40px;
      text-align: center;
      background: linear-gradient(90deg, #1779ff, #4996ff);
      border-radius: 3px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
    }
  }
}
</style>